// eslint-disable-next-line import/prefer-default-export
export function hasAdminRights(myAccount) {
  return myAccount?.permission < 3;
}
